import TeacherProfilePreview from './ProfilePreview.page';

export default TeacherProfilePreview;
